export const KINGDOMS = {
    animalia: 'Animalia',
    plantae: 'Plantae',
    fungi: 'Fungi',
} as const;

export type KingdomKey = keyof typeof KINGDOMS;
export type KingdomName = (typeof KINGDOMS)[KingdomKey];

export interface TargetlistItem {
    kingdom: KingdomName;
    ariseBarcodes: number;
    otherBarcodes: number;
    allBarcodes: number;
    collected: number;
    speciesOccurrenceStatus: string;
}

export interface KingdomStats {
    arise: number;
    other: number;
    total: number;
    shared: number;
    uniqueArisePercent: number;
    totalSpecies: number;
    totalAriseSpecies: number;
    totalOtherSpecies: number;
    totalSharedSpecies: number;
    displayName: string;
}

export type KingdomsData = Partial<Record<KingdomKey, KingdomStats>>;
